"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSession = void 0;
const initSession = (configurationName, storage = sessionStorage) => {
    const clearAsync = (status) => {
        storage[`oidc.${configurationName}`] = JSON.stringify({ tokens: null, status });
        return Promise.resolve();
    };
    const initAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!storage[`oidc.${configurationName}`]) {
            storage[`oidc.${configurationName}`] = JSON.stringify({ tokens: null, status: null });
            return { tokens: null, status: null };
        }
        const data = JSON.parse(storage[`oidc.${configurationName}`]);
        return Promise.resolve({ tokens: data.tokens, status: data.status });
    });
    const setTokens = (tokens) => {
        storage[`oidc.${configurationName}`] = JSON.stringify({ tokens });
    };
    const setSessionStateAsync = (sessionState) => __awaiter(void 0, void 0, void 0, function* () {
        storage[`oidc.session_state.${configurationName}`] = sessionState;
    });
    const getSessionStateAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        return storage[`oidc.session_state.${configurationName}`];
    });
    const setNonceAsync = (nonce) => {
        localStorage[`oidc.nonce.${configurationName}`] = nonce.nonce;
    };
    const getNonceAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        // @ts-ignore
        return { nonce: localStorage[`oidc.nonce.${configurationName}`] };
    });
    const getTokens = () => {
        if (!storage[`oidc.${configurationName}`]) {
            return null;
        }
        return JSON.stringify({ tokens: JSON.parse(storage[`oidc.${configurationName}`]).tokens });
    };
    let getLoginParamsCache = null;
    const setLoginParams = (configurationName, data) => {
        getLoginParamsCache = data;
        storage[`oidc.login.${configurationName}`] = JSON.stringify(data);
    };
    const getLoginParams = (configurationName) => {
        const dataString = storage[`oidc.login.${configurationName}`];
        if (!getLoginParamsCache) {
            getLoginParamsCache = JSON.parse(dataString);
        }
        return getLoginParamsCache;
    };
    const getStateAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        return storage[`oidc.state.${configurationName}`];
    });
    const setStateAsync = (state) => __awaiter(void 0, void 0, void 0, function* () {
        storage[`oidc.state.${configurationName}`] = state;
    });
    const getCodeVerifierAsync = () => __awaiter(void 0, void 0, void 0, function* () {
        return storage[`oidc.code_verifier.${configurationName}`];
    });
    const setCodeVerifierAsync = (codeVerifier) => __awaiter(void 0, void 0, void 0, function* () {
        storage[`oidc.code_verifier.${configurationName}`] = codeVerifier;
    });
    return {
        clearAsync,
        initAsync,
        setTokens,
        getTokens,
        setSessionStateAsync,
        getSessionStateAsync,
        setNonceAsync,
        getNonceAsync,
        setLoginParams,
        getLoginParams,
        getStateAsync,
        setStateAsync,
        getCodeVerifierAsync,
        setCodeVerifierAsync,
    };
};
exports.initSession = initSession;
//# sourceMappingURL=initSession.js.map